// extracted by mini-css-extract-plugin
module.exports = {"list":"books_list_1p0Sk","searchBar":"books_searchBar_1yF1-","item":"books_item_hG_JR","desc":"books_desc_ABRDt","name":"books_name_1l8y2","author":"books_author_2sKOf"};